import { Flex } from 'antd';
import { QuickMenu } from "components/biz";
import { useAuth } from 'hooks/AuthContext';

export const BaseSection = ({children}) => {
  const { user } = useAuth();
  const level_no = user?.level_no ? user?.level_no : 9;
  return (
    <>
    { 
      // level_no 3: 교육원, 4: 강사
      (level_no=== 3 || level_no === 4) ?
        <Flex className='schoolWrap' >
          <Flex vertical gap='7px' className={(level_no=== 3 || level_no=== 4) && 'main-content'}>
              {children}
          </Flex>
          {(level_no=== 3 || level_no=== 4) && <QuickMenu /> }
        </Flex>
      :  
        <Flex vertical gap='7px' style={{padding:'7px', height:'100%'}}>
            {children}
        </Flex>
    }
    </>



  )
}
